import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton } from 'src/components/core'
const UpgradeaICreatorBanner = ({ classes }) => {
  return (
    <div className={classes.certificationContainer}>
      <div className={classes.content}>
        
        <div className={classes.bannerContainer}>
          <div className={classes.bannerContent}>
            <Typography className={classes.bannerSubText}>
              Upgrade to convert your PDFs into engaging, interactive, and
              easily editable mini-courses.
            </Typography>
            <CoreButton
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                window.location.href = '/pricing'
              }}
            >
              See Plans & Upgrade
            </CoreButton>
          </div>
        </div>

        <Typography className={classes.cardTitle}>How it works?</Typography>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/ZJ-CiE8wb4I?si=SWgEU03YCUT6YF8E"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  )
}

export default withStyles(styles)(UpgradeaICreatorBanner)
